// extracted by mini-css-extract-plugin
export default {"title":"ResearchInfoView_title__qHeyQ"};